/**
 * Turns the first-entry coach mark off (the visual fixtures do, unless a case
 * asks for it, so screenshots stay stable). Kept apart from
 * lib/firstEntryNotice so fixtures can import it without the storage layer.
 */
import React from 'react'

export const FirstEntryNoticeEnabledContext = React.createContext(true)
